import React, { useEffect, useState } from "react";
import Loader from "react-loaders";
import { toast } from "react-toastify";
import { Button, Col, Input, Label, Modal, Row } from "reactstrap";
import { userService } from "../../../_services/user.service";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import { api } from "../../../_services/api.service";

const AddUserModal = ({
  isOpen,
  toggleModal,
  partnerId,
  partnerScenarioId,
  reload,
}) => {
  const currentUser = userService.getLoggedInUser();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setUser({
        userID: -1,
        firstName: "",
        lastName: "",
        email: "",
        allTemplates: false,
        partnerID: partnerId,
        partnerRoleID: 2,
        templateCategoryID: 0,
      });
    }
  }, [isOpen]);

  const handleSubmit = async (e, errors, values) => {
    if (errors.length == 0) {
      api
        .createPartnerScenarioUser(currentUser.userId, partnerScenarioId, user)
        .then((id) => {
          toast("User created successfuly", {
            autoClose: 3000,
            type: toast.TYPE.SUCCESS,
            hideProgressBar: false,
          });
          toggleModal();
          reload && reload();
        });

      // api.createPartnerUser(currentUser.userId, user).then((id) => {
      //   toast("User created successfuly", {
      //     autoClose: 3000,
      //     type: toast.TYPE.SUCCESS,
      //     hideProgressBar: false,
      //   });

      //   api.updatePartnerScenarioUser(id, partnerScenarioId, true);
      //   api.getPartnerUserByID(id, partnerId).then((u) => {
      //     setUser(u);
      //   });

      //   toggleModal();
      //   reload && reload();
      // });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={() => {
        toggleModal();
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Add Entity
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal();
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm onSubmit={handleSubmit}>
        <>
          <div className="modal-body">
            {user != null && (
              <>
                <AvField
                  name="first"
                  label="First Name *"
                  value={user.firstName}
                  onChange={(e) =>
                    setUser({ ...user, firstName: e.target.value })
                  }
                  placeholder="Enter..."
                  required
                />
                <AvField
                  name="lastName"
                  label="Last Name *"
                  value={user.lastName}
                  onChange={(e) =>
                    setUser({ ...user, lastName: e.target.value })
                  }
                  placeholder="Enter..."
                  required
                />
                <AvField
                  name="email"
                  label="Email *"
                  value={user.email}
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                  placeholder="Enter..."
                  required
                />
              </>
            )}
          </div>

          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              color="link"
              className="pull-right"
              onClick={() => toggleModal()}
            >
              Cancel
            </Button>
            <Button color="primary" type="submit" className="pull-right">
              Save
            </Button>
            {/* <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={toggleModal}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary save-user"
              onClick={save}
            >
              Save
            </button> */}
          </div>
        </>
      </AvForm>
    </Modal>
  );
};

export default AddUserModal;
